import React, { useCallback, useEffect } from "react";
import '../../css/elements.css';
import { formatTimestamp } from '../../utilities/dashFunction';
import { useSelector, useDispatch } from 'react-redux';
import { setConvoId } from '../../features/conversationSlice';
import { setOpenMessages } from '../../features/topBarSlice';
import BrandedButton, { brandedButtonTypes } from "../../utilities/inputComponents/BrandedButton";

function ConversationPreview({ title }) {

    const dispatch = useDispatch();
    const conversations = useSelector((state) => state.conversations.conversations);
    const handleSelectConvo = (convoId) => {
        dispatch(setOpenMessages(true));
        dispatch(setConvoId(convoId));
    }
    const handleOpenConvos = () => {
        dispatch(setOpenMessages(true));
    }

    return (
        <div className={`frontPageQuilityParentBlockWrapper`}>
            <div className="quilityParentBlockHeader">
                <div className="quilityParentBlockTitle">{title}</div>
            </div>
            <div className="quilityParentBlockContent" style={{ textAlign: 'left' }}>
                {conversations.length > 0 ? (
                    <>
                    {conversations.slice(0, 2).map((convo, index) => (
                        <span className="convoPreviewWrap" onClick={()=>handleSelectConvo(convo.convo_id)} key={`convoPreview${index}`}>
                            <div className="quilityDataLine" key={`filterOption${index}`} style={{ display: 'flex',borderBottom: 'none' }}>
                                <div className="quilityDataLineTitle textOverflowControl" style={{ flex: '2' }}>{convo?.borrower_first ? convo?.borrower_first+' '+convo?.borrower_last : convo?.message_to }</div>
                                <div className="quilityDataLineValue" style={{ flex: '1', cursor: 'pointer' }}></div>
                                <div className="quilityDataLineValue" style={{ cursor: 'pointer' }}>{formatTimestamp(convo.time)}</div>
                            </div>
                            <div className="frontMessagePreview">{convo.message}</div>
                        </span>
                    ))}
                        <div style={{margin: '10px 0px', width: 'fit-content'}}>
                            <BrandedButton
                                clickHandler={_ => handleOpenConvos()}
                                buttonType={brandedButtonTypes.TERTIARY}
                                buttonLabel='See More'
                                labelStyles={{width: '100%'}}
                            />
                        </div>
                    </>
                ) : (
                    "You Have No Conversations"
                )}
            </div>
        </div>
    );
}

export default ConversationPreview;